import React from "react";
import { useHistory } from "react-router";

const useGoBack = (): [() => void] => {
  const history = useHistory();

  return [
    React.useCallback(() => {
      history.goBack();
    }, [history]),
  ];
};

const useCancel = (): [() => void] => {
  const history = useHistory();

  return [
    React.useCallback(() => {
      history.goBack();
    }, [history]),
  ];
};

const useMasterNavigation = (
  route: string
): [
  () => void,
  (id: any) => () => void,
  (node: any) => () => void,
  () => void,
  (id: any) => (event: any) => void,
  (id: any) => () => void,
  (id: any) => () => void
] => {
  const history = useHistory();

  const baseRoute = React.useMemo(() => {
    const listPath = route.split("/");
    return "/" + listPath[listPath.length - 1];
  }, [route]);

  const handleGoCreate = React.useCallback(() => {
    history.push(`${route}${baseRoute}-detail`);
  }, [route, baseRoute, history]);

  const handleGoCreateTree = React.useCallback(
    (node: any) => {
      return () => {
        history.push(`${route}${baseRoute}-detail?id=${node.id}`);
      };
    },
    [route, baseRoute, history]
  );

  const handleGoDetail = React.useCallback(
    (id: any) => {
      return () => {
        history.push(`${route}${baseRoute}-detail?id=${id}`);
      };
    },
    [route, baseRoute, history]
  );

  const handleGoBase = React.useCallback(() => {
    history.replace(`${route}${baseRoute}-master`);
  }, [route, baseRoute, history]);

  const handleGoPreview = React.useCallback(
    (id: any) => {
      return (event: any) => {
        if (event && event.stopPropagation) {
          event.stopPropagation();
        }
        history.push(`${route}${baseRoute}-preview?id=${id}`);
      };
    },
    [route, baseRoute, history]
  );

  const handleGoApproval = React.useCallback(
    (id: any) => {
      return () => {
        history.push(`${route}${baseRoute}-approve?id=${id}`);
      };
    },
    [route, baseRoute, history]
  );

  const handleGoDeviceTypeDetail = React.useCallback(
    (id: any) => {
      return () => {
        history.push(`${route}${baseRoute}-detail?deviceTypeId[equal]=${id}`);
      };
    },
    [route, baseRoute, history]
  );

  return [
    handleGoCreate,
    handleGoDetail,
    handleGoCreateTree,
    handleGoBase,
    handleGoPreview,
    handleGoApproval,
    handleGoDeviceTypeDetail,
  ];
};

export const routerService = {
  useGoBack,
  useCancel,
  useMasterNavigation,
};
